import { SimpleGrid, Square, Text, Box, Center, Container } from '@chakra-ui/react';
import React from 'react';

const Able = () => {
    return (
        <>

            <div style={{ backgroundImage: 'linear-gradient(to bottom, #0a3272, white)' }}>


                <Text
                    // fontWeight="bold"
                    textTransform="uppercase"
                    p={'4px'}
                    pb={'12px'}
                    // align={"right"}
                    fontSize={["30", "33"]}
                    letterSpacing="wide"
                    color="black"
                    pt={[2, 5, 10]}
                    px={[4, 10, 20]}
                    fontWeight='extrabold'
                >
                    सक्षम

                </Text>

                <SimpleGrid columns={1} spacingX={8} mb={7} mt={5}>
                    <Center as={"text"} h='100px' textAlign={'left'} p='3%'
                        fontWeight="bold"
                        textTransform="uppercase"
                        fontSize={["8", "16"]}
                        letterSpacing="wide"
                        color="teal.800"
                    >
                        इस योजना के अंतर्गत एक साल में एक बार एक खिलाड़ी को 5 लाख रूपये तक की वित्तीय सहायता प्रदान की जाएगी।
                    </Center>

                </SimpleGrid>
            </div>


        </>
    )

}
export default Able